<template>
  <v-container>
    <v-form>
      <v-row justify='center'>
        <v-col cols='12' sm='6' md='4' lg='3'>
          <v-card outlined :loading='isLoading'>
            <v-card-text class='text-center'>
              <h2>
                <span class='primary--text'>CPM </span>
                <span class='info--text text--lighten-2'>2.0</span>
              </h2>
              <v-text-field v-model='credentials.username' label='username'></v-text-field>
              <v-text-field v-model='credentials.password' type='password' label='password' v-on:keyup.enter='login'></v-text-field>
              <v-alert v-show='loginError' border='bottom' type='error'>Invalid credentials</v-alert>
            </v-card-text>
            <v-card-actions>
              <v-btn color='error' text :to="{ name: 'ForgotPassword' }">Forgot Password</v-btn>
              <v-spacer></v-spacer>
              <v-btn color='primary' depressed :disabled='isLoading' v-on:keyup.enter='login' @click='login'>Login</v-btn>
            </v-card-actions>
          </v-card>
          <div class='text-center'>
            <small class='grey--text'>
              Westcap Solutions<br>
              &copy; 2020
            </small>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import auth from '@/services/auth';

export default {
  name: 'login',
  data () {
    return {
      response: null,
      isLoading: false,
      credentials: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    loginError: function () {
      if (this.response) {
        console.log(this.response);
        return true;
      }
      return false
    }
  },
  mounted () {
    this.$store.dispatch('closeDrawer')
  },
  methods: {
    async login () {
      this.isLoading = true;
      var loginAxios = this.$axios.create();
      var URL = 'token-auth/';

      await loginAxios.post(URL, this.credentials).then((response) => {
        // The token is stored in localStorage so that it persists even if the user refreshes. When the user DOES refresh
        // then we grab the token from localStorage and use it to re-retrieve all the user's identifying data (profile, etc)
        localStorage.setItem('token', response.data.token)
        auth.setStoreValues(response.data.token).then(() => {
          this.$router.push({ name: 'Dashboard' })
          this.$store.dispatch('openDrawer')
        })
      }).catch((err) => {
        this.response = err
        this.isLoading = false
      })
    }
  }
}
</script>
